// Traducciones de la landing pública (components/Landing/Landing.jsx).
// Archivo aparte de constants/translations.js porque la landing es la home
// de marketing y no comparte vocabulario con la app: se toca por campañas de
// copy, no por features. Se mergea en contexts/LanguageContext.js igual que
// translations-wiki / blogTranslations.
//
// QUÉ NO SE TRADUCE, a propósito:
//  - Nombres de cvars y flags de CS2: son literales que el usuario escribe
//    igual en cualquier idioma. Traducirlos sería mentirle.
//  - Marcas: Steam, Patreon, Config-Strike, Valve.
//
// pt = portugués de Brasil (el selector de la app dice "Português / BR").

export const landingTranslations = {

    // ---------- Botones de sesión ----------
    LANDING_CTA_EDITOR: {
        en: "Go to the editor",
        es: "Ir al editor",
        pt: "Ir para o editor"
    },
    LANDING_CTA_STEAM_LONG: {
        en: "Sign in with Steam",
        es: "Iniciar sesión con Steam",
        pt: "Fazer login com Steam"
    },
    LANDING_CTA_DOWNLOAD: {
        en: "Download the app",
        es: "Descargar la app",
        pt: "Baixar o app"
    },

    // ---------- Hero ----------
    LANDING_HERO_TITLE_1: {
        en: "Setting up CS2",
        es: "Configurar CS2",
        pt: "Configurar o CS2"
    },
    // El título parte en 2 líneas por diseño. En inglés "has never been this
    // easy" se iba a una tercera línea con "easy" sola: "easier" entra igual
    // y mantiene el bloque de 2 líneas de los otros idiomas.
    LANDING_HERO_TITLE_2: {
        en: "has never been easier",
        es: "nunca fue tan fácil",
        pt: "nunca foi tão fácil"
    },
    LANDING_HERO_LEAD: {
        en: "Crosshair, viewmodel, binds, HUD and launch options in a visual editor. No memorizing commands, no fighting the console. Sign in with Steam and your setup follows you wherever you play.",
        es: "Crosshair, viewmodel, binds, HUD y launch options en un editor visual. Sin memorizar comandos, sin pelear con la consola. Iniciás con Steam y tu setup te sigue a donde juegues.",
        pt: "Mira, viewmodel, binds, HUD e opções de inicialização em um editor visual. Sem decorar comandos, sem brigar com o console. Você entra com a Steam e seu setup te acompanha onde você jogar."
    },
    LANDING_HERO_MICRO_1: {
        en: "Free to start",
        es: "Gratis para empezar",
        pt: "Grátis para começar"
    },
    LANDING_HERO_MICRO_2: {
        en: "Syncs with your Steam",
        es: "Sincroniza con tu Steam",
        pt: "Sincroniza com sua Steam"
    },
    LANDING_HERO_MICRO_3: {
        en: "No console commands",
        es: "Sin comandos de consola",
        pt: "Sem comandos de console"
    },

    // ---------- Patreon ----------
    LANDING_PATREON_EYEBROW: {
        en: "support the project",
        es: "apoyá el proyecto",
        pt: "apoie o projeto"
    },
    LANDING_PATREON_TITLE: {
        en: "Join on Patreon",
        es: "Sumate en Patreon",
        pt: "Entre no Patreon"
    },
    LANDING_PATREON_TEXT: {
        en: "Your monthly support keeps the project alive and unlocks the version with more features.",
        es: "Con tu apoyo mensual mantenés el proyecto vivo y desbloqueás la versión con más funciones.",
        pt: "Com seu apoio mensal você mantém o projeto vivo e desbloqueia a versão com mais recursos."
    },
    LANDING_PATREON_CTA: {
        en: "Support on Patreon",
        es: "Apoyar en Patreon",
        pt: "Apoiar no Patreon"
    },
    LANDING_PATREON_UNLOCK_TITLE: {
        en: "What you unlock",
        es: "Lo que desbloqueás",
        pt: "O que você desbloqueia"
    },
    LANDING_PATREON_LI_1: {
        en: "Unlimited profiles and crosshairs",
        es: "Perfiles y miras ilimitados",
        pt: "Perfis e miras ilimitados"
    },
    LANDING_PATREON_LI_2: {
        en: "Sync across all your PCs",
        es: "Sincronización entre todas tus PCs",
        pt: "Sincronização entre todos os seus PCs"
    },
    LANDING_PATREON_LI_3: {
        en: "Themes and skins for the editor",
        es: "Temas y skins para el editor",
        pt: "Temas e skins para o editor"
    },
    LANDING_PATREON_LI_4: {
        en: "Export / import your whole setup",
        es: "Exportar / importar tu setup completo",
        pt: "Exportar / importar seu setup completo"
    },
    LANDING_PATREON_LI_5: {
        en: "Direct support from me",
        es: "Soporte directo conmigo",
        pt: "Suporte direto comigo"
    },

    // ---------- About ----------
    // La tarjeta imita código: se traducen los valores Y las claves, porque
    // leerlas es parte del chiste. Los nombres van en snake_case en los tres
    // idiomas para que siga pareciendo código.
    LANDING_ABOUT_CODE_WHOAMI: {
        en: "// whoami",
        es: "// whoami",
        pt: "// whoami"
    },
    LANDING_ABOUT_CODE_K_DEV: {
        en: "dev",
        es: "dev",
        pt: "dev"
    },
    LANDING_ABOUT_CODE_V_DEV: {
        en: "argentine, CS player for years",
        es: "argentino, jugador de CS hace años",
        pt: "argentino, jogador de CS há anos"
    },
    LANDING_ABOUT_CODE_K_REASON: {
        en: "reason",
        es: "motivo",
        pt: "motivo"
    },
    LANDING_ABOUT_CODE_V_REASON: {
        en: "fed up with the console",
        es: "cansado de la consola",
        pt: "cansado do console"
    },
    LANDING_ABOUT_CODE_K_PROJECT: {
        en: "project",
        es: "proyecto",
        pt: "projeto"
    },
    LANDING_ABOUT_CODE_V_PROJECT: {
        en: "independent · self-hosted",
        es: "independiente · self-hosted",
        pt: "independente · self-hosted"
    },
    LANDING_ABOUT_CODE_K_GROWS: {
        en: "grows_with",
        es: "crece_con",
        pt: "cresce_com"
    },
    LANDING_ABOUT_CODE_V_GROWS: {
        en: "the community",
        es: "la comunidad",
        pt: "a comunidade"
    },
    LANDING_ABOUT_CODE_LOGIN: {
        en: "// sign in with Steam to get going",
        es: "// login con Steam para arrancar",
        pt: "// login com Steam para começar"
    },
    LANDING_ABOUT_EYEBROW: {
        en: "the idea",
        es: "la idea",
        pt: "a ideia"
    },
    LANDING_ABOUT_TITLE: {
        en: "Why Config-Strike exists",
        es: "Por qué existe Config-Strike",
        pt: "Por que o Config-Strike existe"
    },
    LANDING_ABOUT_P1: {
        en: "I've played Counter-Strike for years and it was always the same story: fighting the console, pasting commands copied off a forum, and losing my whole config every time I reinstalled or switched PCs.",
        es: "Juego Counter-Strike desde hace años y siempre me pasó lo mismo: pelearme con la consola, pegar comandos que copiaba de un foro, y perder toda mi config cada vez que reinstalaba o cambiaba de PC.",
        pt: "Jogo Counter-Strike há anos e sempre foi a mesma história: brigar com o console, colar comandos copiados de um fórum e perder toda a minha config sempre que reinstalava ou trocava de PC."
    },
    // Partido por el <b> del medio: 1 + [bold] + 2.
    LANDING_ABOUT_P2_1: {
        en: "Config-Strike was born so anyone can build their setup ",
        es: "Config-Strike nació para que cualquiera pueda armar su setup ",
        pt: "O Config-Strike nasceu para que qualquer um possa montar seu setup "
    },
    LANDING_ABOUT_P2_BOLD: {
        en: "like the pros",
        es: "como los pros",
        pt: "como os pros"
    },
    LANDING_ABOUT_P2_2: {
        en: " from a visual editor: you see what you're changing, you save it to your account and you take it wherever you play. No commands, no losing your work.",
        es: " desde un editor visual: ves lo que tocás, lo guardás en tu cuenta y te lo llevás a donde juegues. Nada de comandos, nada de perder tu laburo.",
        pt: " a partir de um editor visual: você vê o que está mexendo, salva na sua conta e leva para onde jogar. Sem comandos, sem perder seu trabalho."
    },
    LANDING_ABOUT_P3: {
        en: "It's an independent project that I build and maintain myself, running on my own server. It grows with the people who use it and back it — every feature that lands comes from what the community asks for.",
        es: "Es un proyecto independiente que hago y mantengo yo, corriendo en mi propio servidor. Crece con la gente que lo usa y lo banca — cada feature que viene sale de lo que pide la comunidad.",
        pt: "É um projeto independente que eu faço e mantenho sozinho, rodando no meu próprio servidor. Ele cresce com quem usa e apoia — cada recurso que chega sai do que a comunidade pede."
    },
    LANDING_ABOUT_SIGN: {
        en: "— An Argentine dev, shovel in hand",
        es: "— Un dev argentino, con la pala en la mano",
        pt: "— Um dev argentino, com a pá na mão"
    },

    // ---------- Footer ----------
    LANDING_FOOT_LEGAL_1: {
        en: "© 2026 Config-Strike · Independent project",
        es: "© 2026 Config-Strike · Proyecto independiente",
        pt: "© 2026 Config-Strike · Projeto independente"
    },
    LANDING_FOOT_LEGAL_2: {
        en: "Not affiliated with Valve or Steam. CS2 is a trademark of Valve Corporation.",
        es: "No afiliado a Valve ni a Steam. CS2 es marca de Valve Corporation.",
        pt: "Não afiliado à Valve nem à Steam. CS2 é marca da Valve Corporation."
    }
}
